'use client';
/* eslint-disable tailwindcss/no-custom-classname */
import { useId } from 'react';
import OpenInNew from '../../components/icons/OpenInNew';
import { RichText } from '../../components/RichText';
import { QuoteHighlightProps } from './types';

export const QuoteHighlight = ({
  title,
  quote,
  reviewLinkText,
  reviewLinkUrl,
  pushDataLayer,
}: QuoteHighlightProps): JSX.Element | null => {
  const titleId = useId();
  const hasLink = Boolean(reviewLinkText && reviewLinkUrl);

  if (!title && !quote && !hasLink) {
    return null;
  }

  if (reviewLinkText && !reviewLinkUrl) {
    console.warn(
      'QuoteHighlight: reviewLinkUrl is missing, hiding review link.',
    );
  }

  const handleLinkClick = () => {
    pushDataLayer?.({
      event: 'navigate-click',
    });
  };

  return (
    <section
      aria-labelledby={title ? titleId : undefined}
      className="w-full bg-fill/primary-light px-spacing/padding/section-x py-spacing/padding/section-y"
    >
      <div className="mx-auto flex w-full flex-col md:w-general/narrow-content-max-width-3 md:max-w-general/narrow-content-max-width-3">
        <div className="flex w-full flex-col items-start gap-spacing/gap/y text-left md:mx-auto md:w-general/narrow-content-max-width-1 md:max-w-general/narrow-content-max-width-1 md:items-center md:text-center">
          {title && (
            <h2
              id={titleId}
              className="mhg-alpha-typography-display-1 text-fill/primary"
            >
              {title}
            </h2>
          )}

          {quote && (
            <RichText className="mhg-alpha-typography-body-1-relaxed w-full text-text/primary [&_p]:m-0 [&_a]:pointer-events-none [&_a]:no-underline">
              {quote}
            </RichText>
          )}

          {hasLink && (
            <a
              href={reviewLinkUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mhg-alpha-typography-body-1 inline-flex items-center gap-1 underline text-text/link underline-offset-2 transition-colors hover:text-fill/primary-dark focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-primary focus-visible:ring-offset-2 focus-visible:ring-offset-fill/primary-light"
              onClick={handleLinkClick}
            >
              <span>{reviewLinkText}</span>
              <OpenInNew className="size-shapes/icon-size-md shrink-0" />
            </a>
          )}
        </div>
      </div>
    </section>
  );
};
